import { render, staticRenderFns } from "./GirisYap.vue?vue&type=template&id=49ab4aac&"
import script from "./GirisYap.vue?vue&type=script&lang=js&"
export * from "./GirisYap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports